import { render, staticRenderFns } from "./PageEmployees.vue?vue&type=template&id=5ad54e36&scoped=true&"
import script from "./PageEmployees.vue?vue&type=script&lang=js&"
export * from "./PageEmployees.vue?vue&type=script&lang=js&"
import style0 from "./PageEmployees.vue?vue&type=style&index=0&id=5ad54e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad54e36",
  null
  
)

export default component.exports